import React, { Component } from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import moment from 'moment';

import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { AddressSplit } from '../services/utilities/AddressSplit';
import FieldApi from '../services/field/FieldApi';
import FieldCcusApi from '../services/FieldCcus';
import FieldService from '../services/Fields';

import * as FormEle from '../components/FieldFormElements';
import { FieldFormElementsReadOnly } from '../components/FieldFormElementsReadOnly';
import { FieldCcusForm } from '../components/forms/FieldCcusForm'; // Ccusフォーム
import { ccusStore } from '../components/FieldFormElementsCcusProvider'; // Ccusフォーム
import {
  createFormEventManager,
  Form,
  SwitchForm,
} from '../components/FormBase';

import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { BankenInfoDialog } from '../components/modals/BankenInfoDialog';
import { Confirmation } from '../components/modals/common';
import { messageUtility } from '../utilities/messageUtility';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { isTargetRoleId } from '../utilities/roleUtility';
import {
  APPROVAL_STATUS,
  USER_ROLES,
  HEADER_CONSTANTS,
  CCUS_ORDER_TYPE,
  CCUS_CONSTRUCTURE_TYPE,
  CONTRACT_FLAG,
  PAGE_REFERER,
  SESSION_KEY_ITEM,
  DATE_TIME_FORMAT,
  API_FLAG,
} from '../utilities/constants';
import fetchMg from '../utilities/fetchManager';
import _urlParamManager from '../utilities/urlParamManager';

import styles from '../styles/componentStyle/entrance/fieldForm.scss';
import { MasterPageHeader } from '../components/PageHeader';
import {
  FormList,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { FieldNaviList } from '../components/list/FieldNaviList';
import SystemUseHistoryDialog from '../components/dialogs/SystemUseHistoryDialog';

/**
 * 現場詳細画面 / 現場申請詳細画面
 * 画面遷移
 *  1. 現場一覧>>データ行[編集]>>現場詳細画面
 *  2. 新規現場申請承認>>データ行[編集]>>現場申請詳細画面
 */
export class FieldsDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      params: {}, // 現場情報を保持
      company: {}, // 元請会社情報を保持
      company_branch: {}, // 支店情報を保持
      beforePageReferer: null,
      fieldId: null,
      roleId: null,
      jvFlag: true, // JV会社フラグ(編集ボタンの表示状態に使用)
      isChangingApprovalStatus: false, //承認状態変更中フラグ
      dialogMsg: '', // ダイアログメッセージ
      dialogTitle: '',
      updateSuccess: false, // 更新完了フラグ
      statusFlag: null, // 申請/承認/否認フラグ
      showModal: false, //投稿成功
      isShowClearCcusIdConfirmDialog: false,
      disabledCooperationCcus: true,
      visibleSystemUseHistoryDialog: false,
      systemUseHistoryList: [],
      roanToChoseiFlg: false, // 労安からの遷移先が直接「現場詳細」か、黒メニュー「現場一覧」経由かを区別するフラグ
      isShowBankenInfoDialog: false,
    };

    // Form で使うEventManagerを取得
    this.FormEventMg = createFormEventManager();
    this.updatingFlag = false; // 多重登録防止Flag
    this.isRequestingFlag = false;

    // slideLoaderからの情報を取得
    if (props.view) {
      this.state.fieldId = props.view.state.id;
    } else if (props.match) {
      this.state.fieldId = props.match.params.id;
    }

    this.state.roleId = LocalStorageService.getRoleId(); // ロールID

    if (
      props.view.state.pageReferer !== null &&
      props.view.state.pageReferer !== '' &&
      props.view.state.pageReferer !== undefined
    ) {
      SessionStorageService.setItem(
        SESSION_KEY_ITEM.beforePageName,
        props.view.state.pageReferer
      );
    }

    this.state.roanToChoseiFlg = this.isDirectRoanFlg();
    if (this.state.roanToChoseiFlg) {
      // 労安側からの遷移の場合
      // 労務安全から遷移してくる場合、対象の現場はすでに承認済みであり現場詳細画面を表示すべきであるため、
      // 前回表示画面（beforePageReferer）を現場一覧として扱うことにより後続処理で現場詳細画面の表示に切り替える
      this.state.beforePageReferer = PAGE_REFERER.fields.key;
    } else {
      this.state.beforePageReferer = SessionStorageService.getItem(
        SESSION_KEY_ITEM.beforePageName
      );
    }

    // buildeeとの契約無しの状態で、URL直叩き遷移防止処理
    const contractFlag = SessionStorageService.getContractFlag();
    if (
      contractFlag === CONTRACT_FLAG.noContract.id &&
      isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], this.state.roleId)
    ) {
      return window.location.replace('/error-permission');
    }
  }

  UNSAFE_componentWillMount() {
    this.onLoad();
  }

  /**
   * 労務安全から直接遷移してきたかどうかを判定する
   * @return {boolean} true:労安側から直接現場詳細への遷移, false:黒メニューの現場一覧からの遷移
   */
  isDirectRoanFlg = () => {
    let judgement = false;
    if (SessionStorageService.getRoanToChoseiFlg()) {
      // セッションに判定フラグが格納されている場合
      judgement = true;
      SessionStorageService.removeRoanToChoseiFlg();
      _urlParamManager.removeUrlParam('roanToChoseiFlg');
    }
    return judgement;
  };

  /**
   * 現場詳細か現場申請詳細かのタイトル文字列を返す
   * @param {boolean} roanToChoseiFlg true: 労安からの遷移先が直接「現場詳細」, false: 労安からの遷移先が黒メニュー「現場一覧」経由
   * @param {number} approvalFlag  1: 承認済の現場「現場詳細」, 0: 未承認の現場「現場申請詳細」, 2: 否認された現場「現場申請詳細」
   * @return {string} 画面表示用の文字列
   */
  getTitleName = (approvalFlag, roanToChoseiFlg) => {
    let title = '';
    if (roanToChoseiFlg || approvalFlag === APPROVAL_STATUS.approval.id) {
      // 労務安全から直接遷移もしくは承認済の現場の場合、現場詳細
      title = data.pageTitle.fieldDetail;
    } else if (
      approvalFlag === APPROVAL_STATUS.unapproved.id ||
      approvalFlag === APPROVAL_STATUS.disapproval.id
    ) {
      // 未承認の現場もしくは否認された現場の場合、現場申請詳細
      title = data.pageTitle.fieldRequestDetail;
    }
    return title;
  };

  /**
   * 一つ前の画面名を返す
   * @param {boolean} roanToChoseiFlg true: 労安からの遷移先が直接「現場詳細」, false: 労安からの遷移先が黒メニュー「現場一覧」経由
   * @param {number} approvalFlag  1: 承認済の現場「現場一覧」, 0: 未承認の現場「新規現場申請承認」, 2: 否認された現場「新規現場申請承認」
   * @return {string} リンクの文字列
   */
  getBeforePageName = (approvalFlag, roanToChoseiFlg) => {
    let name = '';
    if (roanToChoseiFlg || approvalFlag === APPROVAL_STATUS.approval.id) {
      // 労務安全から直接遷移もしくは承認済現場の場合、現場一覧
      name = PAGE_REFERER.fields.name;
    } else if (
      // 未承認の現場もしくは否認された現場の場合、新規現場申請承認
      approvalFlag === APPROVAL_STATUS.unapproved.id ||
      approvalFlag === APPROVAL_STATUS.disapproval.id
    ) {
      name = PAGE_REFERER.fieldRequestList.name;
    }

    return name;
  };

  /**
   * @description 現場情報をロードする
   */
  onLoad() {
    const stateValue = _.cloneDeep(this.state);

    FieldApi.loadField(this.state.fieldId)
      .then(response => {
        if (response.result) {
          stateValue.params = _.cloneDeep(response.data.entities.field);

          // URL直接遷移時などbeforePageRefererが特定できないときのみapproval_flagで確認する
          if (
            !this.state.beforePageReferer &&
            _.has(response.data.entities.field, 'approval_flag')
          ) {
            switch (response.data.entities.field.approval_flag) {
              case APPROVAL_STATUS.approval.id:
                stateValue.beforePageReferer = PAGE_REFERER.fields.key;
                SessionStorageService.setItem(
                  SESSION_KEY_ITEM.beforePageName,
                  PAGE_REFERER.fields.key
                );
                break;
              case APPROVAL_STATUS.unapproved.id:
                stateValue.beforePageReferer =
                  PAGE_REFERER.fieldRequestList.key;
                SessionStorageService.setItem(
                  SESSION_KEY_ITEM.beforePageName,
                  PAGE_REFERER.fieldRequestList.key
                );
                break;
              // BLDE_V2-50383: 否認ケースの追加
              case APPROVAL_STATUS.disapproval.id:
                stateValue.beforePageReferer =
                  PAGE_REFERER.fieldRequestList.key;
                SessionStorageService.setItem(
                  SESSION_KEY_ITEM.beforePageName,
                  PAGE_REFERER.fieldRequestList.key
                );
                break;
              default:
                break;
            }
          }

          //addressがあり、分割済み住所がなければ住所を分割
          if (
            (stateValue.params.address !== null ||
              stateValue.params.address !== undefined) &&
            (stateValue.params.address_prefecture === null ||
              stateValue.params.address_prefecture === undefined)
          ) {
            const _address = AddressSplit(stateValue.params.address);
            if (_address) {
              stateValue.params.address_prefecture =
                stateValue.params.address_prefecture || _address.prefecture;
              stateValue.params.address_city =
                stateValue.params.address_city || _address.other;
            }
          }

          //office_addressがあれば住所を分割
          if (
            (stateValue.params.office_address !== null ||
              stateValue.params.office_address !== undefined) &&
            (stateValue.params.office_address_prefecture === null ||
              stateValue.params.office_address_prefecture === undefined)
          ) {
            const _address = AddressSplit(stateValue.params.office_address);
            if (_address) {
              stateValue.params.office_address_prefecture =
                stateValue.params.office_address_prefecture ||
                _address.prefecture;
              stateValue.params.office_address_city =
                stateValue.params.office_address_city || _address.other;
            }
          }

          let jvFlag = false;
          if (
            !_.isEmpty(stateValue.params.jvs) &&
            stateValue.params.approval_flag === APPROVAL_STATUS.approval.id
          ) {
            const company_id = Number(SessionStorageService.getCompanyId());
            const main_company_id = stateValue.params.company.company_id;
            if (company_id !== main_company_id) {
              jvFlag = true;
            }
          }
          stateValue.company = stateValue.params.company;
          stateValue.company_branch = {
            id: stateValue.params.company.company_branch_id,
            name: stateValue.params.company.company_branch_name,
          };
          stateValue.jvFlag = jvFlag;

          // console.log('FieldsDetail.jsx onLoad', stateValue.params);

          // 入退場管理システム/労務安全システムの使用フラグパラメータ
          // use_gk_flg === use_entrance_flg
          // use_roan_flg === use_greenfile_flg
          // 前者から後者に移行されるため、2020/08/13 現在は同じ値が送られているが
          // 前者は不要なので削除する
          if (!_.isUndefined(stateValue.params.use_gk_flg)) {
            delete stateValue.params.use_gk_flg;
          }
          if (!_.isUndefined(stateValue.params.use_roan_flg)) {
            delete stateValue.params.use_roan_flg;
          }
          const params = {
            company_branch_id: stateValue.company_branch.id,
          };

          return fetchMg
            .GetAjax('/api/private/company_branches/list', params)
            .then(response => {
              if (response.result) {
                stateValue.params.changeable_progress_flg = _.get(
                  response,
                  'data.entities.company_branches[0].available_progress_flg'
                );
              } else {
                throw new Error('FieldsForm.jsx onLoad after GetAjax');
              }
            });
        } else {
          stateValue.dialogMsg = _.has(response, 'message')
            ? response.message
            : messageUtility.getMessage('E-000-001');
          stateValue.updateSucces = false;
          stateValue.showModal = true;
        }
      })
      .catch(error => {
        stateValue.dialogMsg = _.has(error, 'message')
          ? error.message
          : messageUtility.getMessage('E-000-001');
        stateValue.updateSucces = false;
        stateValue.showModal = true;
      })
      .finally(() => {
        this.setState(stateValue, this.onLoadPermissionFieldTreeCooperation);
      });
  }

  /**
   * @description load permission field tree cooperation with ccus
   */
  onLoadPermissionFieldTreeCooperation = () => {
    if (_.isEmpty(_.get(this.state, 'params.ccus_site_id'))) {
      return this.setState({
        disabledCooperationCcus: true,
      });
    }

    FieldCcusApi.checkPermissionFieldTreeCooperationWithCcus(
      this.state.fieldId
    ).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        disabledCooperationCcus: !_.get(
          response,
          'data.entities.enable_ccus_flag'
        ),
      });
    });
  };

  /**
   * @description 現場の承認状態を変更する
   * @param {boolean} status 申請/承認/否認フラグ
   */
  async updateFieldApprovedStatus(status) {
    // 多重登録防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    if (this.state.fieldId) {
      const mStatus = status;
      const params = { approval_flag: mStatus };
      this.setState({
        isChangingApprovalStatus: true,
      });
      let stateValue = _.cloneDeep(this.state);

      FieldApi.updateFieldApprovedStatus(this.state.fieldId, params)
        .then(response => {
          if (response.result) {
            let dialogMsg = '';
            let dialogTitle = '';
            if (mStatus === APPROVAL_STATUS.approval.id) {
              dialogTitle = '現場を承認';
              dialogMsg = `${this.state.params.name}を承認しました。`;
            } else if (mStatus === APPROVAL_STATUS.disapproval.id) {
              dialogTitle = '現場を否認';
              dialogMsg = `${this.state.params.name}を否認しました。`;
            } else if (mStatus === APPROVAL_STATUS.unapproved.id) {
              dialogTitle = '現場申請完了';
              dialogMsg = `現場の申請が完了しました。`;
            }
            ccusStore.destroy();
            stateValue = _.assign(stateValue, {
              dialogMsg,
              dialogTitle,
              updateSucces: true,
              statusFlag: mStatus,
              showModal: true,
            });
          }
        })
        .catch(() => {
          stateValue = _.assign(stateValue, {
            dialogMsg: messageUtility.getMessage('E-000-032'),
            updateSucces: false,
            showModal: true,
          });
        })
        .finally(() => {
          stateValue.isChangingApprovalStatus = false;
          this.setState(stateValue);
          this.updatingFlag = false;
        });
    }
  }

  clickSystemUseHistory = fieldId => {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    FieldService.systemUseHistoryList(fieldId)
      .then(response => {
        if (!response.result) {
          console.error(
            'Fields.jsx',
            'clickSystemUseHistory',
            'FieldService.systemUseHistoryList !response.result',
            response
          );
          return;
        }
        this.setState({
          systemUseHistoryList: response.data.entities.contract_histories,
          visibleSystemUseHistoryDialog: true,
        });
      })
      .catch(error => {
        console.error(
          'Fields.jsx',
          'clickSystemUseHistory',
          'FieldService.systemUseHistoryList catch',
          error
        );
      })
      .finally(() => {
        this.isRequestingFlag = false;
      });
  };

  /**
   * CCUSクリアダイアログを表示する
   */
  showCcusClearDialog = () => {
    const state = { ...this.state };
    state.isShowClearCcusIdConfirmDialog = true;
    this.setState(state);
  };

  /**
   * CCUSクリアダイアログを閉じる
   */
  closeCcusClearDialog = () => {
    const state = { ...this.state };
    state.isShowClearCcusIdConfirmDialog = false;
    this.setState(state);
  };

  /**
   * CCUSIDをクリアしてダイアログを閉じる
   */
  clearCcusIdAndCloseDialog = async () => {
    if (this.state.fieldId) {
      const response = await FieldCcusApi.clearCcusSiteId({
        field_id: this.state.fieldId,
      });
      if (response.result) {
        this.setState({
          isShowClearCcusIdConfirmDialog: false,
          params: {
            ...this.state.params,
            ccus_site_id: null,
          },
          disabledCooperationCcus: true,
        });
      } else {
        this.setState({
          isShowClearCcusIdConfirmDialog: false,
          dialogTitle: messageUtility.getMessage('E-001-426'),
          dialogMsg: _.has(response.data, 'message')
            ? response.data.message
            : messageUtility.getMessage('E-000-001'),
          updateSucces: false,
          showModal: true,
        });
      }
    }
  };

  /**
   * @description BLDE_V2-48023 BANKEN案内ダイアログを表示させる条件チェック
   * @returns {boolean} すべての条件を満たせばtrue、そうでなければfalse
   */
  shouldShowBankenDialog = () => {
    // 入退場管理フラグ
    const useEntranceFlagIsOn =
      this.state.params.use_entrance_flg === API_FLAG.On;
    return useEntranceFlagIsOn;
  };

  render() {
    // console.log('FieldsDetail.jsx render', this.state.params);

    const {
      params,
      company,
      company_branch,
      beforePageReferer,
      fieldId,
      roleId,
      jvFlag,
      isChangingApprovalStatus,
      disabledCooperationCcus,
      visibleSystemUseHistoryDialog,
      systemUseHistoryList,
      roanToChoseiFlg,
    } = this.state;
    let title = this.getTitleName(params.approval_flag, roanToChoseiFlg);

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <TopHeader
            approvalFlag={params.approval_flag}
            roanToChoseiFlg={roanToChoseiFlg}
            getTitleName={this.getTitleName}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <FieldNaviList
                  fieldId={fieldId}
                  selectedTab='FieldsDetail'
                  disabledCooperationCcus={disabledCooperationCcus}
                  showJvSettingTab={
                    beforePageReferer === PAGE_REFERER.fields.key ? true : false
                  }
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <LinkHeader
                  approvalFlag={params.approval_flag}
                  roanToChoseiFlg={roanToChoseiFlg}
                  getBeforePageName={this.getBeforePageName}
                />
                {!jvFlag && (
                  <MenuButtons
                    params={params}
                    fieldId={fieldId}
                    roleId={roleId}
                    isChangingApprovalStatus={isChangingApprovalStatus}
                    updateFieldApprovedStatus={this.updateFieldApprovedStatus.bind(
                      this
                    )}
                    roanToChoseiFlg={roanToChoseiFlg}
                  />
                )}

                <div className='contruction-detail-view__bar' />

                {/* ここからフォーム */}
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
                  {/* リスト型フォーム */}
                  <FormList>
                    <FieldCcusForm
                      disabled={true}
                      ccusid={params.ccus_site_id}
                    />
                    <Form EventMg={this.FormEventMg}>
                      {params.ccus_site_id && (
                        <FormEle.CcusId
                          defaultValue={params.ccus_site_id}
                          isShowDeleteButton={!jvFlag}
                          onDelete={this.showCcusClearDialog}
                        />
                      )}
                      <FormEle.CompanyName
                        fieldsDetail={true}
                        defaultValue={company.company_name}
                      />

                      <FormEle.CompanyBranch
                        disabled
                        id='company_branch_id'
                        defaultValue={company_branch}
                      />
                      <FieldFormElementsReadOnly
                        label={'現場名'}
                        value={params.name}
                        isRequireIconShow={false}
                      />

                      <FormEle.FieldSelectCommon
                        id='ordering_type_id'
                        labelTitle={'発注区分'}
                        items={_.map(Object.keys(CCUS_ORDER_TYPE), item => {
                          return CCUS_ORDER_TYPE[item];
                        })}
                        defaultValue={this.state.params.ordering_type_id}
                        disabled
                      />
                      <FormEle.FieldSelectCommon
                        id='construction_type_id'
                        labelTitle={'工事種類'}
                        items={_.map(
                          Object.keys(CCUS_CONSTRUCTURE_TYPE),
                          item => {
                            return CCUS_CONSTRUCTURE_TYPE[item];
                          }
                        )}
                        defaultValue={params.construction_type_id}
                        disabled
                      />
                      <FormListSubHeader title={'現場情報'} />
                      <FormEle.FieldPostalCode
                        disabled
                        id='postal_code'
                        defaultValue={params.postal_code}
                      />
                      <FormEle.FieldPrefecture
                        id='address_prefecture'
                        disabled
                        defaultValue={params.address_prefecture || ''}
                      />
                      <FormEle.FieldInputCommon
                        id='address_city'
                        labelTitle={'市区町村'}
                        disabled
                        defaultValue={params.address_city || ''}
                      />
                      <FormEle.FieldInputCommon
                        id='address_city_kana'
                        labelTitle={'市区町村(フリガナ)'}
                        disabled
                        defaultValue={params.address_city_kana}
                      />
                      <FormEle.FieldInputCommon
                        id='address_add_1'
                        labelTitle={messageUtility.getMessage('I-000-189')}
                        disabled
                        defaultValue={params.address_add_1}
                      />
                      <FormEle.FieldInputCommon
                        id='address_add_1_kana'
                        labelTitle={'その他1（フリガナ）'}
                        disabled
                        defaultValue={params.address_add_1_kana}
                      />
                      <FormEle.FieldInputCommon
                        id='address_add_2'
                        labelTitle={'その他2（建物名など）'}
                        disabled
                        optional={true}
                        defaultValue={params.address_add_2}
                      />
                      <FormEle.FieldInputCommon
                        id='address_add_2_kana'
                        labelTitle={'その他2（フリガナ）'}
                        disabled
                        optional={true}
                        defaultValue={params.address_add_2_kana}
                      />
                      <FormListSubHeader title={'事務所情報'} />
                      <FormEle.OfficePostalCode
                        disabled
                        id='office_postal_code'
                        defaultValue={params.office_postal_code}
                      />
                      <FormEle.FieldPrefecture
                        id='office_address_prefecture'
                        disabled
                        defaultValue={params.office_address_prefecture || ''}
                      />
                      <FormEle.FieldInputCommon
                        id='office_address_city'
                        labelTitle={'市区町村'}
                        disabled
                        defaultValue={params.office_address_city || ''}
                      />
                      <FormEle.FieldInputCommon
                        id='office_address_city_kana'
                        labelTitle={'市区町村(フリガナ)'}
                        disabled
                        defaultValue={params.office_address_city_kana}
                      />
                      <FormEle.FieldInputCommon
                        id='office_address_add_1'
                        labelTitle={messageUtility.getMessage('I-000-189')}
                        disabled
                        defaultValue={params.office_address_add_1}
                      />
                      <FormEle.FieldInputCommon
                        id='office_address_add_1_kana'
                        labelTitle={'その他1（フリガナ）'}
                        disabled
                        defaultValue={params.office_address_add_1_kana}
                      />
                      <FormEle.FieldInputCommon
                        id='office_address_add_2'
                        labelTitle={'その他2（建物名など）'}
                        disabled
                        optional={true}
                        defaultValue={params.office_address_add_2}
                      />
                      <FormEle.FieldInputCommon
                        id='office_address_add_2_kana'
                        labelTitle={'その他2（フリガナ）'}
                        disabled
                        optional={true}
                        defaultValue={params.office_address_add_2_kana}
                      />
                      <FormEle.OfficeTell
                        disabled
                        id='tel'
                        defaultValue={params.tel}
                      />
                      <FormListSubHeader title={'工期・労働時間情報'} />
                      <FormEle.GroundBreakingDate
                        disabled
                        id='groundbreaking_date'
                        defaultValue={params.groundbreaking_date}
                      />
                      <FormEle.CompleteScheduleDate
                        disabled
                        id='complete_schedule_date'
                        defaultValue={params.complete_schedule_date}
                      />
                      <FormEle.BuildeeEndDay
                        disabled={true}
                        value={params.usage_end_date}
                        validate={''}
                        onUpdate={() => {}}
                      />
                      <FormEle.WorkTimeType
                        disabled
                        defaultValue={params}
                        validate={{}}
                      />
                      <FormEle.NestForm disabled defaultValue={params} />

                      <FormEle.DailyWorkTime
                        disabled
                        defaultValue={params.work_hour}
                      />
                      <FormListSubHeader title={'管理者情報'} />
                      <FieldFormElementsReadOnly
                        label={'所長名'}
                        value={params.charge_name}
                        isRequireIconShow={false}
                      />
                      <FieldFormElementsReadOnly
                        label={'所長名ふりがな'}
                        value={params.charge_name_kana}
                        isRequireIconShow={false}
                      />
                      {/* 現場監督の時は、表示しない */}
                      <SwitchForm
                        show={
                          beforePageReferer === PAGE_REFERER.fields.key ||
                          isTargetRoleId(
                            [USER_ROLES.prime, USER_ROLES.branch],
                            roleId
                          )
                        }
                      >
                        <FormEle.BuildeeTantousya
                          disabled
                          defaultValue={params.buildee_user}
                        />
                        <FormEle.BuildeeTantouEmail
                          disabled
                          defaultValue={
                            _.has(params.buildee_user, 'email')
                              ? params.buildee_user.email
                              : null
                          }
                        />
                      </SwitchForm>
                      <FieldFormElementsReadOnly
                        label={'部署'}
                        value={params.department}
                      />
                      <FormEle.FieldInputCommon
                        id='manager_id'
                        labelTitle='CCUS管理者ID'
                        maxLength={16}
                        defaultValue={params.manager_id}
                        disabled
                      />
                      <FormListSubHeader title={'その他の設定'} />
                      <FormEle.StartDay
                        disabled
                        id='start_day'
                        defaultValue={params.start_day}
                      />
                      <FormEle.ApprovalDays
                        disabled
                        id='approval_days'
                        defaultValue={params.approval_days}
                      />
                      <FormEle.UsePartnerCompanyApprovalFlag
                        disabled
                        id='use_partner_company_approval_flag'
                        defaultValue={params.use_partner_company_approval_flag}
                      />
                      {/* BLDE_V2-26961
                      <FormEle.PartnerInputResultFlag
                        disabled
                        name='PartnerInputResultFlag'
                        defaultValue={params.partner_input_result_flag}
                      />
                      */}
                      <FormEle.AdjustWorkPrintFlag
                        disabled
                        name='AdjustWorkPrintFlag'
                        defaultValue={params.adjust_work_print_flag}
                      />
                      <FormEle.CraneUsePrintFlag
                        disabled
                        name='CraneUsePrintFlag'
                        defaultValue={params.crane_use_print_flag}
                      />
                      <FormEle.WorkAndDiaryPrintFlag
                        disabled
                        name='WorkAndDiaryPrintFlag'
                        defaultValue={params.work_and_diary_print_flag}
                      />

                      <FormEle.ManagementNo
                        disabled
                        id='management_no'
                        defaultValue={params.management_no}
                      />

                      {/* JV 追加フォーム */}
                      {beforePageReferer !== PAGE_REFERER.fields.key && (
                        <FormEle.JV
                          disabled
                          detailFlg
                          defaultValue={params.jvs}
                        />
                      )}

                      <FieldFormElementsReadOnly
                        label={'登録日'}
                        value={moment(new Date(params.created_at)).format(
                          DATE_TIME_FORMAT.weekdaySlashDateTimeSecondFormat
                        )}
                      />
                      <FieldFormElementsReadOnly
                        label={'更新日'}
                        value={moment(
                          new Date(params.overall_updated_at)
                        ).format(
                          DATE_TIME_FORMAT.weekdaySlashDateTimeSecondFormat
                        )}
                      />
                      <FormListSubHeader title={'利用するサービス'} />
                      <FormEle.UseEntranceSystem
                        disabled={true}
                        value={this.state.params.use_entrance_flg}
                        onUpdate={() => {}}
                      />
                      <FormEle.UseGreenFileSystem
                        disabled={true}
                        value={this.state.params.use_greenfile_flg}
                        onUpdate={() => {}}
                      />
                      {params.changeable_progress_flg && (
                        <FormEle.UseProgressSystem
                          disabled={true}
                          value={this.state.params.use_progress_flg}
                          onUpdate={() => {}}
                        />
                      )}
                      <FormEle.ContractorButton
                        fieldId={fieldId}
                        onClickSystemUseHistory={this.clickSystemUseHistory}
                      />
                    </Form>
                  </FormList>
                </div>
                <Modal modalRoot='root' modalState={this.state.showModal}>
                  <DialogSuccessError
                    msg={this.state.dialogTitle}
                    msgDetail={this.state.dialogMsg}
                    updateSuccess={this.state.updateSucces}
                    success={() => {
                      if (
                        this.state.statusFlag === APPROVAL_STATUS.approval.id
                      ) {
                        if (this.shouldShowBankenDialog()) {
                          // BLDE_V2-48023 - 入退場管理機能がONの場合、BANKEN案内ダイアログを表示
                          this.setState({ isShowBankenInfoDialog: true });
                        } else {
                          _masterSlideLoader.show(PAGE_REFERER.fields.key, {
                            state: {},
                          });
                        }
                      } else {
                        _masterSlideLoader.show(
                          PAGE_REFERER.fieldRequestList.key,
                          {
                            state: {},
                          }
                        );
                      }
                    }}
                    error={() => {
                      this.setState({ showModal: false });
                      window.location.reload();
                    }}
                    multilineText={true}
                  />
                </Modal>
              </div>
            </div>
          </div>
        </div>
        <SystemUseHistoryDialog
          visible={visibleSystemUseHistoryDialog}
          systemUseHistoryList={systemUseHistoryList}
          isUseProgressService={params.changeable_progress_flg}
          onClose={() => {
            this.setState({ visibleSystemUseHistoryDialog: false });
          }}
        />
        <Confirmation
          visible={this.state.isShowClearCcusIdConfirmDialog === true}
          title={messageUtility.getMessage('I-000-171')}
          message={messageUtility.getMessage('I-000-172')}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          rootClassName='dialog--wide'
          isNegative={true}
          multilineText={true}
          onCancel={this.closeCcusClearDialog}
          onConfirm={this.clearCcusIdAndCloseDialog}
          negativeButtonClassName='btn--negative'
        />
        <BankenInfoDialog
          visible={this.state.isShowBankenInfoDialog}
          onClose={() => {
            _masterSlideLoader.show(PAGE_REFERER.fields.key, {
              state: {},
            });
          }}
        />
      </div>
    );
  }
}

/**
 * @description 一番上のヘッダー
 */
const TopHeader = ({ approvalFlag, roanToChoseiFlg, getTitleName }) => {
  let title = getTitleName(approvalFlag, roanToChoseiFlg);
  return (
    <MasterPageHeader
      title={
        <React.Fragment>
          <div>{title}</div>
        </React.Fragment>
      }
      onClose={() => moveToBeforePage(approvalFlag, true, roanToChoseiFlg)}
    />
  );
};
const moveToBeforePage = (approvalFlag, isclose, roanToChoseiFlg) => {
  let beforePage = PAGE_REFERER.fields.key;
  if (isclose && roanToChoseiFlg) {
    // 閉じるボタンクリック時
    ccusStore.destroy();
    _masterSlideLoader.close();
  } else {
    // 現場一覧リンククリック時
    ccusStore.destroy();
    // BLDE_V2-50704: approvalFlagによって遷移先を決断する
    //1: 承認済の現場「現場一覧」,
    //0: 未承認の現場「新規現場申請承認」, 2: 否認された現場「新規現場申請承認」
    if (roanToChoseiFlg || approvalFlag === APPROVAL_STATUS.approval.id) {
      beforePage = PAGE_REFERER.fields.key;
    } else if (
      approvalFlag === APPROVAL_STATUS.unapproved.id ||
      approvalFlag === APPROVAL_STATUS.disapproval.id
    ) {
      beforePage = PAGE_REFERER.fieldRequestList.key;
    }

    _masterSlideLoader.show(beforePage, {
      state: {},
    });
  }
};

/**
 * @description リンク部分
 */
const LinkHeader = ({ approvalFlag, roanToChoseiFlg, getBeforePageName }) => {
  const state = { ...this.state };
  let beforePageName = getBeforePageName(approvalFlag, roanToChoseiFlg);
  return (
    <div className='contruction-detail-view__header'>
      <button
        className='btn-text--sm'
        onClick={() => moveToBeforePage(approvalFlag, false, roanToChoseiFlg)}
      >
        <i className='i-back--blue i-2x vertical-middle' />
        {beforePageName}
      </button>
    </div>
  );
};

/**
 * @description ボタン部分
 */

const MenuButtons = ({
  params,
  fieldId,
  roleId,
  isChangingApprovalStatus,
  updateFieldApprovedStatus,
  roanToChoseiFlg,
}) => (
  <div className='contruction-detail-view__menu'>
    {!roanToChoseiFlg &&
      isTargetRoleId([USER_ROLES.prime, USER_ROLES.branch], roleId) && (
        <React.Fragment>
          {params.approval_flag !== APPROVAL_STATUS.approval.id && (
            <span className='construction-detail-view__button'>
              <button
                className={`${styles['btn_disabled']} btn--effective`}
                disabled={isChangingApprovalStatus}
                onClick={() =>
                  updateFieldApprovedStatus(APPROVAL_STATUS.approval.id)
                }
              >
                {data.buttonTitle.approve}
              </button>
            </span>
          )}
          {params.approval_flag !== APPROVAL_STATUS.disapproval.id &&
            params.approval_flag !== APPROVAL_STATUS.approval.id && (
              <span className='construction-detail-view__button'>
                <button
                  className={`${styles['btn_disabled']} btn--negative`}
                  disabled={isChangingApprovalStatus}
                  onClick={() =>
                    updateFieldApprovedStatus(APPROVAL_STATUS.disapproval.id)
                  }
                >
                  {data.buttonTitle.unapproved}
                </button>
              </span>
            )}
        </React.Fragment>
      )}
    {!roanToChoseiFlg &&
      isTargetRoleId([USER_ROLES.manager], roleId) &&
      params.approval_flag === APPROVAL_STATUS.disapproval.id && (
        <React.Fragment>
          <span className='construction-detail-view__button'>
            <button
              className={`${styles['btn_disabled']} btn--effective`}
              disabled={isChangingApprovalStatus}
              onClick={() =>
                updateFieldApprovedStatus(APPROVAL_STATUS.unapproved.id)
              }
            >
              {data.buttonTitle.request}
            </button>
          </span>
        </React.Fragment>
      )}
    <span className='construction-detail-view__button'>
      <button
        className={`${styles['btn_disabled']} btn`}
        disabled={isChangingApprovalStatus}
        onClick={() => {
          const id = `${fieldId}`;
          if (roanToChoseiFlg) {
            SessionStorageService.setRoanToChoseiFlg(roanToChoseiFlg);
          }
          _masterSlideLoader.show(data.pageName.edit, { state: { id } });
        }}
      >
        {data.buttonTitle.edit}
      </button>
    </span>
  </div>
);

const data = {
  pageTitle: {
    fieldDetail: '現場詳細',
    fieldRequestDetail: '現場申請詳細',
  },
  buttonTitle: {
    approve: '承認',
    unapproved: '否認',
    request: '申請',
    edit: '編集',
  },
  pageName: {
    edit: 'FieldsForm',
  },
};



// WEBPACK FOOTER //
// ./src/pages/FieldsDetail.jsx